import { cdnApi } from '@/helpers/api'
import { useAsyncState } from '@vueuse/core'
import { defineStore } from 'pinia'

export interface IMapleConnection {
  ytVideo: string
  title: string
}

interface IMapleHeroes {
  [key: string]: string
}

interface IAdvancedSkills {
  [key: string]: string
}

interface IBannerCarouselItem {
  name: string
  image: string
  imageMobile: string
  link: string
  openInNewWindow: boolean
}
interface IBannerCarousel {
  rotationTime: number
  Children: Array<IBannerCarouselItem>
}

export const useHomeContentsStore = defineStore('HomeContents', () => {
  const mapleConnection = ref<Array<IMapleConnection>>([])
  const mapleHeroes = ref<Array<IMapleHeroes>>([])
  const advancedSkills = ref<Array<IAdvancedSkills>>([])

  const bannerVideo = ref('')
  const bannerCarousel = ref<IBannerCarousel>({ rotationTime: 5, Children: [] })

  const { state, isReady } = useAsyncState(() => cdnApi.get('/home-page').then((res) => res.data), {})

  watch(isReady, () => {
    // MapleConnection
    mapleConnection.value = [
      { ytVideo: state.value.youtubeForMC1, title: state.value.titleForMC1 },
      { ytVideo: state.value.youtubeForMC2, title: state.value.titleForMC2 },
      { ytVideo: state.value.youtubeForMC3, title: state.value.titleForMC3 },
    ]

    // MapleHeroes
    const mapleHeroesAvailableList = ['darkKnight', 'magician', 'bowman', 'thief', 'pirate']

    for (const mapleHero of mapleHeroesAvailableList) {
      mapleHeroes.value.push(state.value[mapleHero])
    }
    // AdvancedSkills
    const advancedSkillsAvailableList = ['thiefSkill', 'bowmanSkill', 'magicianSkill', 'pirateSkill', 'warrierSkill']
    for (const advancedSkill of advancedSkillsAvailableList) {
      advancedSkills.value.push(state.value[`${advancedSkill}`])
    }

    // banner carousel
    bannerCarousel.value = state.value.Children[0]
    bannerCarousel.value.rotationTime = parseInt(state.value.Children[0].rotationTime, 10)

    // BannerVideo
    bannerVideo.value = state.value.bannerVideo
  })

  return {
    mapleConnection,
    mapleHeroes,
    advancedSkills,
    bannerVideo,
    bannerCarousel,
  }
})
